<template>
    <v-container
            fluid
            tag="section"
            pt-0
    >
        <v-row>
            <v-col cols="12">
                <v-data-table
                        :headers="headers"
                        :items="userList.users"
                        :options.sync="options"
                        :server-items-length="userList.userCount"
                        sort-by="name"
                        class="elevation-1"
                >
                    <template v-slot:top>
                        <v-toolbar
                                flat
                        >
                            <v-select
                                    outlined
                                    dense
                                    :label="$vuetify.lang.t('$vuetify.page.Users.roles')"
                                    v-model="filterRole"
                                    :items="roleList"
                                    item-text="name"
                                    item-value="name"
                                    :menu-props="{closeOnContentClick: true}"
                                    :hide-details="true"
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item
                                            ripple
                                            @click="filterRole = null"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title>
                                                Все
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>
                            </v-select>
                            <v-text-field
                                    class="ml-2"
                                    outlined
                                    dense
                                    :label="$vuetify.lang.t('$vuetify.page.Users.searchByName')"
                                    v-model="searchByName"
                                    :hide-details="true"
                            ></v-text-field>
                            <v-spacer></v-spacer>
                            <v-dialog
                                    v-model="dialog"
                                    max-width="500px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                            color="primary"
                                            dark
                                            class="mb-2"
                                            v-bind="attrs"
                                            v-on="on"
                                    >
                                        {{$vuetify.lang.t('$vuetify.page.action.btnAdd')}}
                                    </v-btn>
                                </template>
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-form
                                                ref="form_addNewUser"
                                                v-model="valid"
                                                lazy-validation
                                        >
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                            cols="6"
                                                    >
                                                        <v-text-field
                                                                v-model="editedItem.username"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.username')"
                                                                :rules="[fieldValidationRules.required(vue)]"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            cols="6"
                                                    >
                                                        <v-text-field
                                                                v-model="editedItem.displayName"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.displayName')"
                                                                :rules="[fieldValidationRules.required(vue)]"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            cols="6"
                                                    >
                                                        <v-text-field
                                                                v-model="editedItem.email"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.email')"
                                                                :rules="[fieldValidationRules.required(vue), fieldValidationRules.email(vue)]"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            cols="6"
                                                    >
                                                        <v-select
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.roles')"
                                                                v-model="editedItem.roles"
                                                                :items="roleList"
                                                                item-text="name"
                                                                item-value="name"
                                                                multiple
                                                        >
                                                        </v-select>
                                                    </v-col>
                                                    <v-col
                                                            cols="6"
                                                    >
                                                        <v-text-field
                                                                type="password"
                                                                v-model="editedItem.password"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.password')"
                                                                :rules="[fieldValidationRules.required(vue), fieldValidationRules.newPassword(vue)]"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            cols="6"
                                                    >
                                                        <v-text-field
                                                                type="password"
                                                                v-model="editedItem.confirmPassword"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.confirmPassword')"
                                                                :rules="[fieldValidationRules.required(vue), confirmPassword]"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            cols="6"
                                                    >
                                                        <v-text-field
                                                                v-model="editedItem.phone"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.phone')"
                                                                v-mask="'+7 (###) ###-##-##'"
                                                        ></v-text-field>
                                                    </v-col>

                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="close"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                        </v-btn>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="addNewUser"
                                                :loading="axiosLoading" :disabled="!valid"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog
                                    v-model="editDialog"
                                    max-width="500px"
                            >
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-form
                                                ref="form_setUserAttribute"
                                                v-model="valid"
                                                lazy-validation
                                        >
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                            cols="12"
                                                    >
                                                        <v-text-field
                                                                v-model="editedItem.displayName"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.displayName')"
                                                                :rules="[fieldValidationRules.required(vue), fieldValidationRules.maxLength(vue, 64)]"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="close"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                        </v-btn>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="setUserAttribute"
                                                :loading="axiosLoading" :disabled="!valid"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog
                                    v-model="changePasswordDialog"
                                    max-width="500px"
                            >
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Смена пароля</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-form
                                                ref="form_changePassword"
                                                v-model="valid"
                                                lazy-validation
                                        >
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                            cols="12"
                                                    >
                                                        <v-text-field
                                                                type="password"
                                                                v-model="editedItem.password"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.newPassword')"
                                                                :rules="[fieldValidationRules.required(vue), fieldValidationRules.newPassword(vue)]"
                                                        ></v-text-field>
                                                    </v-col>
                                                    <v-col
                                                            cols="12"
                                                    >
                                                        <v-text-field
                                                                type="password"
                                                                v-model="editedItem.confirmPassword"
                                                                :label="$vuetify.lang.t('$vuetify.page.Users.confirmPassword')"
                                                                :rules="[fieldValidationRules.required(vue), confirmPassword]"
                                                        ></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="close"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                        </v-btn>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="changePassword"
                                                :loading="axiosLoading" :disabled="!valid"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog
                                    v-model="editRolesDialog"
                                    max-width="500px"
                            >
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">Роли</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-form>
                                            <v-container>
                                                <v-row>
                                                    <v-col
                                                            cols="12"
                                                    >
                                                        <v-select
                                                            :label="$vuetify.lang.t('$vuetify.page.Users.roles')"
                                                            v-model="editedItem.roles"
                                                            multiple
                                                            :items="roleList"
                                                            item-text="name"
                                                            item-value="name"
                                                        ></v-select>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="close"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnCancel')}}
                                        </v-btn>
                                        <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="changeRoles"
                                                :loading="axiosLoading" :disabled="!valid"
                                        >
                                            {{$vuetify.lang.t('$vuetify.page.action.btnSave')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.isDisabled="{ item }">
                        <v-chip
                                v-if="item.isDisabled"
                                color="red"
                                dark
                        >
                            Нет
                        </v-chip>
                        <v-chip
                                v-else
                                color="green"
                                dark
                        >
                            Да
                        </v-chip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        color="primary"
                                        dark
                                        small
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                >
                                    <v-icon>
                                        mdi-dots-vertical
                                    </v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item
                                        @click="editAttributeItem(item)"
                                >
                                    <v-list-item-title>Редактировать</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                        @click="editRolesItem(item)"
                                >
                                    <v-list-item-title>Изменить роли</v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item
                                        @click="changePasswordDialogOpen(item)"
                                >
                                    <v-list-item-title>Сменить пароль</v-list-item-title>
                                </v-list-item>

                                <v-divider></v-divider>
                                <v-list-item
                                    v-if="item.isDisabled"
                                    @click="setStatus(item.id, false)"
                                >
                                    <v-list-item-title>Активировать</v-list-item-title>
                                </v-list-item>
                                <v-list-item
                                    v-if="!item.isDisabled"
                                    @click="setStatus(item.id, true)"
                                >
                                    <v-list-item-title>Деактивировать</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-slot:no-data>
                        Нет данных
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {mapState} from "vuex";
    import {mask} from 'vue-the-mask'

    export default {
        name: "Users",
        directives: {mask},
        created() {
            this.$store.dispatch('retrieveRoleList')
        },
        computed: {
            ...mapState(['barColor', 'barImage']),
            roleList() {
                return this.$store.getters.roleList
            },
            roleListDict() {
                return this.$store.getters.roleList
            },
            userList() {
                return this.$store.getters.userList
            },
            formTitle() {
                return this.editedIndex === -1
                    ? this.$vuetify.lang.t('$vuetify.page.action.formAddTitle', this.$vuetify.lang.t('$vuetify.page.Users.crudName'))
                    : this.$vuetify.lang.t('$vuetify.page.action.formEditTitle', this.$vuetify.lang.t('$vuetify.page.Users.crudName'))
            },
            confirmPassword(){
                return value => {
                    return value === this.editedItem.password || (this.$vuetify ? this.$vuetify.lang.t('$vuetify.validation.confirmPassword') : '')
                }
            },
        },
        watch: {
            options: {
                handler () {
                    this.getUserList()
                },
                deep: true,
            },
            filterRole: {
                handler () {
                    this.getUserList()
                },
                deep: true,
            },
            searchByName: {
                handler () {
                    this.getUserList()
                },
                deep: true,
            }
        },
        data() {
          return {
              vue: this,
              valid: !this.formError,
              dialog: false,
              editDialog: false,
              changePasswordDialog: false,
              editRolesDialog: false,
              dialogDelete: false,
              options: {},
              filterRole: null,
              searchByName: null,
              headers: [
                  {
                      text: this.$vuetify.lang.t('$vuetify.page.Users.username'),
                      align: 'start',
                      sortable: true,
                      value: 'username',
                  },
                  {
                      text: this.$vuetify.lang.t('$vuetify.page.Users.displayName'),
                      align: 'start',
                      sortable: true,
                      value: 'displayName',
                  },
                  {
                      text: this.$vuetify.lang.t('$vuetify.page.Users.email'),
                      align: 'start',
                      sortable: true,
                      value: 'email',
                  },
                  {
                      text: this.$vuetify.lang.t('$vuetify.page.Users.phone'),
                      align: 'start',
                      sortable: true,
                      value: 'phone',
                  },
                  {
                      text: this.$vuetify.lang.t('$vuetify.page.Users.roles'),
                      align: 'start',
                      sortable: true,
                      value: 'roles',
                  },
                  {
                      text: this.$vuetify.lang.t('$vuetify.page.Users.isDisabled'),
                      align: 'start',
                      sortable: true,
                      value: 'isDisabled',
                  },
                  {text: this.$vuetify.lang.t('$vuetify.page.action.titleAction'), value: 'actions', sortable: false},
              ],
              editedIndex: -1,
              editedItem: {
                  id: null,
                  displayName: '',
              },
              defaultItem: {
                  email: null,
                  username: null,
                  displayName: null,
                  password: null,
                  roles: [],
                  phone: null
              },
          }
        },
        methods: {
            getUserList(){
                this.$store.dispatch('retrieveUserList', {
                    offset: this.options.itemsPerPage * (this.options.page-1),
                    limit: this.options.itemsPerPage,
                    role: this.filterRole,
                    search: this.searchByName
                })
            },
            editAttributeItem(item) {
                this.editedIndex = this.userList.users.indexOf(item)

                this.editedItem = Object.assign({}, item)
                this.editedItem.isUpdate = true
                this.editDialog = true
            },
            changePasswordDialogOpen(item) {
                this.editedIndex = this.userList.users.indexOf(item)

                this.editedItem = Object.assign({}, item)
                this.editedItem.password = null
                this.editedItem.confirmPassword = null
                this.changePasswordDialog = true
            },
            editRolesItem(item) {
                this.editedIndex = this.userList.users.indexOf(item)

                this.editedItem = Object.assign({}, item)
                this.editRolesDialog = true
            },
            deleteItem(item) {
                this.editedIndex = this.userList.users.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },
            close() {
                this.dialog = false
                this.editDialog = false
                this.changePasswordDialog = false
                this.editRolesDialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            closeDelete() {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            addNewUser() {
                if (this.$refs.form_addNewUser.validate()) {
                    this.editedItem.id = this.$uuid.v4()
                    this.$store.dispatch('registerUser', this.editedItem).then(() => this.close())
                }
            },
            setStatus(id, status){
                this.$store.dispatch('setUserStatus', {
                    id: id,
                    isDisabled: status
                })
            },
            setUserAttribute(){
                if (this.$refs.form_setUserAttribute.validate()) {
                    this.$store.dispatch('editUserAttribute', {
                        id: this.editedItem.id,
                        displayName: this.editedItem.displayName
                    }).then(() => this.close())
                }
            },
            changePassword() {
                if (this.$refs.form_changePassword.validate()) {
                    this.$store.dispatch('changeUserPassword', {
                        id: this.editedItem.id,
                        newPassword: this.editedItem.password
                    }).then(() => this.close())
                }
            },
            changeRoles(){
                this.$store.dispatch('changeRoles', {
                    id: this.editedItem.id,
                    roles: this.editedItem.roles
                }).then(() => this.close())

            }
        }
    }
</script>

<style scoped>

</style>